/**
 * Test IDs for QA automation.
 */
export const testIds = {
  invoiceListCustomer: "invoice-list-customer",
  invoiceListShipper: "invoice-list-shipper",
  invoiceListReceiver: "invoice-list-receiver",
  invoiceListNotInvoicedNavigation: "invoice-list-not-invoiced-navigation",
  invoiceListNotInvoicedView: "invoice-list-not-invoiced-view",
  invoiceListInProcess: "invoice-list-in-process",
  invoiceListInvoiced: "invoice-list-invoiced",
  invoiceListPaid: "invoice-list-paid",
  invoiceListTransferred: "invoice-list-transferred",
  invoiceListOnHold: "invoice-list-on-hold",
  invoiceListCancelled: "invoice-list-cancelled",
  invoiceListBatchProcess: "invoice-list-batch-process",
  invoiceListClosingNote: "invoice-list-closing-note",
  invoiceListCancelClosingNote: "invoice-list-cancel-closing-note",
  invoiceListSaveClosingNote: "invoice-list-save-closing-note",
} as const;
